import { FieldPath, FieldValues, get, useController } from 'react-hook-form';

import { FormNumberInput, FormNumberInputProps } from '@britishcouncil/react-admin';

import { RHFormFieldProps } from './types';

type RHFormNumberInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = RHFormFieldProps<
  FormNumberInputProps<number> & { min?: number; max?: number },
  TFieldValues,
  TName
>;

export const RHFormNumberInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  shouldUnregister,
  defaultValue,
  ...props
}: RHFormNumberInputProps<TFieldValues, TName>) => {
  const { field, formState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });

  const handleChange = (value: number | undefined) => {
    if (value === undefined || value === null) {
      field.onChange(value);
      return;
    }
    const numValue = Number(value);
    if (props.min !== undefined && numValue < props.min) {
      field.onChange(props.min);
    } else if (props.max !== undefined && numValue > props.max) {
      field.onChange(props.max);
    } else {
      field.onChange(numValue);
    }
  };

  return (
    <FormNumberInput
      {...props}
      name={field.name}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
      touched
      error={get(formState.errors, field.name)?.message}
    />
  );
};
